<div class="text-center text-muted">    
    <h3 style="word-break: break-word;">{{album.name}}</h3>
    <h4 style="word-break: break-word;"><i>{{albumPage.name}}</i></h4>
</div>
<div style="position:relative;">
    <div><span>{{LOCALIZATION.created}}:</span> {{album.createdStr}}</div>
    <div><span>{{LOCALIZATION.modified}}:</span> {{album.modifiedStr}}</div>
    <div><span>{{LOCALIZATION.pages}}:</span> {{album.pages}}</div>
    <div *ngIf="album.description" class="doc-summary" style="margin:8px 0;">{{album.description}}</div>
</div>
 
<div style="position:relative;">
	<div> 
         <div class="text-center text-muted">
             <h3><u>{{LOCALIZATION.pageMetadata}}</u></h3>
             <div>
                 <button *ngIf='userPermissions["ROLE_PRODUCT_UPDATE_PAGE_DESCRIPTION"] && isUpdate' 
                 	(click)='toggleUpdate(false)' 
                 	class='btn btn-xs btn-default'>
                 		{{LOCALIZATION.cancel}}
                 </button>             
                 <button *ngIf='userPermissions["ROLE_PRODUCT_UPDATE_PAGE_DESCRIPTION"] && !isUpdate && canUpdate' 
                 	(click)='toggleUpdate(true)' 
                 	class='btn btn-xs btn-primary'>
                 		{{LOCALIZATION.edit}}
                 </button>
                 <button *ngIf='userPermissions["ROLE_PRODUCT_UPDATE_PAGE_DESCRIPTION"] && isUpdate && canUpdate' 
                 	(click)='savePage()' 
                 	class='btn btn-xs btn-primary'>
                 		{{LOCALIZATION.save}}
                 </button>
             </div>    
         </div>
         <div class="album_page_metadata">
			    <form #kvForm="ngForm" name="kvForm" class="form-signin">
			        <div class="row">
			            <div class="col-md-12">
			                <label for="title">{{LOCALIZATION.name}}</label>
			                <input [(ngModel)]='input.title' id="title" name="pageName" 
			                	maxlength="{{limits.title}}" type="text" 
			                	class="form-control" placeholder="Page Name" 
								[readonly]="!isUpdate || !canUpdate" />
			                <span class="help-block pull-right">{{input.title.length||0}}/{{limits.title}}</span>				                
			            </div>
			            <div class="col-md-12">
			                <label for="description">{{LOCALIZATION.description}}</label>
							<textarea [(ngModel)]='input.description' id="description" name="description"  
								class="form-control" style="margin:0px; max-width:99%; height:200px; border:1px solid #9e9e9e;" 
								maxlength="{{limits.description}}" cols="90" 
								placeholder="Page Description" aria-label="Page Description"
								[readonly]="!isUpdate || !canUpdate"></textarea>                	
			                    <span class="help-block pull-right">{{input.description.length||0}}/{{limits.description}}</span>
			            </div>
			        </div>
			    </form>                
         </div>	
	</div>
</div>            